
<template>
  <!--物业公司管理-->
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="propertyId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
    >
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'company',
  data () {
    return {
      apiOrigin: 'JAVA',
      searchList: [
        { label: '', props: ['keywords'], placeholder: '公司名、手机号', inputType: 'input' },
        {
          label: '',
          props: ['areaId'],
          placeholder: '选择省市',
          options: [],
          inputType: 'cascader',
          changeOnSelect: true,
          expandTrigger: 'click',
          loadData: e => {
            this.regionSelect(1, 'searchList', '1,2,3', e);
          }
        },
        { label: '', props: ['verifyStatus'], placeholder: '状态', options: [], inputType: 'select' },
        { label: '', props: ['createDate'], placeholder: ['审核时间', '审核时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', permi: ['community:property:add'] }
      ],
      rowOptList: [
        {
          text: '',
          handle: (row) => this.toAudit(row),
          rowOptText: row => row.verifyStatus === 1 ? '查看' : '审核', // 0: 未审核；1: 审核通过；2：拒绝
          customRender: true,
          permi: ['community:property:query']
        },
        {
          text: '修改',
          handle: (row) => this.$refs.table.toEdit(row, ['verifyStatus']),
          permi: ['community:property:edit']
        },
        { text: '删除', handle: (row) => this.$refs.table.showDeleteConfirm(row), permi: ['community:property:remove'] },
        [
          { text: '收费配置', handle: (row) => this.toPayment(row), permi: ['community:property:config'] }
        ]
      ],
      columns: [
        { title: '所在城市', dataIndex: 'area', align: 'left', width: '' },
        { title: '物业公司名称', dataIndex: 'propertyFullName', align: 'left', width: '' },
        { title: '联系人手机', dataIndex: 'mobilePhone', align: 'left', width: '' },
        { title: '审核人', dataIndex: 'verifyUser', align: 'left', width: '' },
        { title: '审核时间', dataIndex: 'checkTime', align: 'left', width: '' },
        { title: '状态', dataIndex: 'verifyStatusDesc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        keywords: '',
        areaId: '',
        verifyStatus: '',
        createDate: []
      },
      listApi: {
        url: '/property/list',
        resHandle: this.resHandle,
        searchHandle: '' // this.searchHandle
      },
      addHandleParam: {
        route: 'addCompany',
        addTitle: '新增物业公司',
        editTitle: '修改物业公司'
      },
      deleteParam: {
        url: '/property/',
        // param: {pk_key: 'propertyId', pk_val: ''},

        title: '物业公司',
        key: 'propertyFullName'
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    /* 获取下拉 */
    getSelect () {
      // this.propertyManageSelect([{index: 2, key: 'check_status'}]);
      this.dictionarySelect([{index: 2, scope: 'searchList', query: 'comu_verify_type'}]);
      this.regionSelect(1);
    },
    toAudit (row) {
      this.$router.push({
        name: 'auditCompany',
        query: {
          title: row.verifyStatus !== 0 ? '物业公司详情' : '物业公司审核',
          id: row.propertyId,
          status: `${row.verifyStatus}`
        }
      });
    },
    // 前往收费配置页面
    toPayment (row) {
      this.$router.push({
        name: 'payment',
        query: {
          id: row.propertyId
        }
      });
    },
    resHandle (res) {
      res.forEach((ele) => {
        ele.address = `${ele.provinceName} ${ele.cityNname}`;
      });
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
